module.exports = __webpack_public_path__ + "img/b14419d7ea3993dfdc50faa3cbd70cc8.jpg";